<template>
  <div class="clock-widget breaks">
    <div v-if="breaks.length > 0" class="breaks-header">
      <div class="breaks-item switch">
        <div class="breaks-icon">
          <button type="button" @click="closeBreaks">
            <img
              src="../../../images/arrow-black-small.svg"
              alt="Break Codes"
            />
          </button>
          <span>{{ label.get("break_preferences_break_types") }}</span>
        </div>
        <div class="switch" v-if="canManageBreakRules">
          <button type="button" @click="manageBreakCodes">
            <span>{{ label.get("manage_break_codes") }}</span>
            <img src="../../../images/right-arrow.svg" alt="Switch Arrow" />
          </button>
        </div>
      </div>
      <div class="breaks-item search">
        <span class="search-box">
          <img src="../../../images/small-search-icon.svg" alt="Search Icon" />
        </span>
        <input
          v-model="search"
          type="search"
          :placeholder="label.get('search')"
        />
      </div>
    </div>
    <div v-if="breaks.length > 0" class="breaks-content">
      <div class="radio-button">
        <div
          v-for="(item, idx) in filteredBreaks"
          :key="idx"
          class="radio-button-content"
        >
          <b-form-radio
            name="break_id"
            v-model="selectedBreak"
            :value="item.id"
          >
            {{ item.name }}
          </b-form-radio>
        </div>
      </div>
      <div class="buttons-container">
        <button
          v-if="!breakCode"
          class="add-break-button"
          type="button"
          @click="addBreak"
          :disabled="disabledBtn"
        >
          <div v-if="disabledBtn" class="btn-loader" />
          <span v-if="!disabledBtn">{{ label.get("add_break") }}</span>
        </button>
      </div>
    </div>
    <div v-if="breaks.length === 0" class="clock-widget types">
      <button type="button" class="close-button" @click="closeBreaks">
        <img src="../../../images/close-popup-btn.svg" alt="Close" />
      </button>
      <div class="types-content">
        <img src="../../../images/no-break-types.svg" alt="Type" />
        <h1>{{ label.get("no_break_codes_available") }}</h1>
        <p>
          {{ label.get("no_break_codes_available_description") }}
        </p>
        <button
          v-if="canManageBreakRules"
          type="button"
          class="add-types"
          @click="addBreakCodes"
        >
          <span>{{ label.get("add_break_types") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BreaksWidgetComponent",
  props: {
    breakCode: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      breaks: this.$store.state.breakCodes,
      selectedBreak: this.break ? this.break.break_code_id : null,
      search: "",
      disabledBtn: false,
    };
  },
  computed: {
    filteredBreaks() {
      return this.breaks.filter((item) => {
        return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
    },
    canManageBreakRules() {
      return this.$store.state.user.role_id !== 3;
    },
  },
  methods: {
    closeBreaks() {
      this.$emit("onBreaksClose");
    },
    manageBreakCodes() {
      this.$router.push({ path: '/settings/break-preferences' });
    },
    addBreakCodes() {
      this.$root.$emit("showAddBreakCode");
    },
    addBreak() {
      if (!this.selectedBreak) {
        return;
      }
      this.disabledBtn = true;
      this.$emit("onBreakAdded", this.selectedBreak);
    },
  },
};
</script>

<style lang="scss">
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}

.clock-widget.breaks {
  position: absolute;
  top: 0;
  left: 0;
  height: auto !important;
  .breaks-header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: auto;
    background: #fff;
    z-index: 5;
    .breaks-item {
      width: 100%;
      height: 24px;
    }
    .breaks-item.switch {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 73px;
      background: #fafafa;
      border-bottom: 1px solid #efefef;
      padding: 27px;
      .breaks-icon {
        img {
          margin-top: -5px;
        }
        span {
          margin-left: 12px;
          font-size: 1.25rem;
          line-height: 1.75rem;
          color: #262626;
          font-weight: 500;
          text-transform: capitalize;
        }
      }
      .switch {
        span {
          margin-left: 5px;
          font-size: 0.875rem;
          line-height: 1.5rem;
          font-weight: 500;
          color: #262626;
          text-transform: capitalize;
        }
      }
    }
    .breaks-item.search {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 48px;
      border-bottom: 1px solid #efefef;
      padding: 0 27px;
      .search-box {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      input {
        padding-left: 13px;
        width: calc(100% - 24px);
        @include mobile {
          width: 90%;
        }
        border: none;
        background: transparent;
        font-size: 0.875rem;
        line-height: 1.5rem;
        color: #262626;
        &::placeholder {
          font-size: 0.875rem;
          line-height: 1.5rem;
          color: #999999;
        }
      }
    }
  }
  .breaks-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 399px;
    padding: 0 24px 40px 24px;
    background: #fff;
    z-index: 5;
    .radio-button {
      width: 100%;
      height: calc(100% - 65px);
      overflow-y: auto;

      .radio-button-content {
        position: relative;
        margin: 0;
        border: 0;
        width: 100%;
        height: 55px;
        display: flex;
        align-items: center;
        .custom-control.custom-radio {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
          font-size: 0.875rem;
          color: #262626;
          text-align: left;
          text-transform: capitalize;
          cursor: pointer;
          .custom-control-label {
            padding: 10px;
            width: 100%;
            border-bottom: 1px solid #efefef;
            &:before {
              top: 10px;
            }
            &:after {
              top: 16px;
            }
          }
        }
      }
    }
    .buttons-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      button {
        width: 158px;
        height: 48px;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        span {
          font-size: 1.125rem;
          color: #ffffff;
          font-weight: bold;
          text-transform: uppercase;
        }
        &.add-break-button {
          width: 100%;
          background: #00b9cb;
          &:hover {
            background: #0a9ead;
            .btn-loader {
              border-left-color: #0a9ead;
            }
          }
        }
      }
    }
  }
  .clock-widget.types {
    padding: 32px;
    background: #fff;
    z-index: 5;
    display: flex;
    flex-direction: column;
    height: 100%;
    button.close-button {
      align-self: flex-end;
    }
    .types-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: calc(100% - 58px);
      h1,
      p {
        text-align: center;
        text-transform: lowercase;
        &::first-letter {
          text-transform: uppercase;
        }
      }
      h1 {
        padding-top: 28px;
        padding-bottom: 8px;
        font-size: 1.375rem;
        line-height: 1.625rem;
        color: #262626;
        font-weight: 500;
      }
      p {
        font-size: 0.9375rem;
        line-height: 1.5rem;
        color: #666666;
        font-weight: lighter;
        padding: 0 15px 15px;
      }
      button.add-types {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 190px;
        height: 40px;
        border-radius: 20px;
        background: #262626;
        &:hover {
          background: #000000;
        }
        span {
          font-size: 0.9375rem;
          line-height: 1.125rem;
          color: #ffffff;
          font-weight: 600;
          text-transform: uppercase;
        }
      }
    }
  }
}
.time-clock-container.with-header {
  .breaks-content {
    height: 472px;
  }
}
</style>
